import { Locale } from 'src/modules/locale';
import { ProductLocalizedEntity } from '../products';

//Both types included: Image component and Strapi Media type
export interface ImageEntity {
  id?: string;
  url: string;
  alt?: string;
  alternativeText?: string;
  position?: ImagePosition;
  caption?: string;
  image?: { url: string };
  locale?: Locale;
  width?: number;
  height?: number;
  products?: ProductLocalizedEntity[];
}

export enum ImagePosition {
  Left = 'left',
  Right = 'right',
}
export enum ImageType {
  Raw = 'Raw',
  HalfRow = 'HalfRow',
  FullRow = 'FullRow',
  ThreeFourth = '3/4',
}

export enum CardType {
  Big = 'Big',
  Small = 'Small',
}

export enum CardTheme {
  Product = 'Product',
  Overview = 'Overview',
  Article = 'Article',
}
